/**
 * Saltos a secciones dentro de la misma página.
 *
 * Horizon deja `overflow: hidden` en html y body y desplaza `.page-wrapper`,
 * así que un enlace `#seccion` no mueve nada por su cuenta: el navegador
 * intenta desplazar el documento, que no scrollea.
 *
 * `scrollIntoView` sí sabe encontrar el contenedor con scroll real y respeta
 * el `scroll-margin-block-start` de la sección, que es lo que impide que la
 * cabecera pegajosa tape su arranque. Calcularlo a mano era frágil: la
 * posición cambia mientras cargan las imágenes de más abajo.
 */

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

function goTo(target) {
  target.scrollIntoView({
    block: 'start',
    behavior: window.matchMedia(REDUCED_MOTION).matches ? 'auto' : 'smooth',
  });
}

function targetOf(hash) {
  if (!hash || hash.length < 2) return null;
  return document.getElementById(decodeURIComponent(hash.slice(1)));
}

/*
 * En `window` y en fase de captura a propósito: es el primer nodo del recorrido
 * del evento, así que este manejador corre antes que los de Horizon, que también
 * escuchan clics en enlaces. `stopImmediatePropagation` evita que ninguno de
 * ellos interrumpa después el desplazamiento ya iniciado.
 */
window.addEventListener(
  'click',
  (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || !link.hash) return;
    if (link.pathname !== window.location.pathname || link.host !== window.location.host) return;

    const target = targetOf(link.hash);
    if (!target) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    goTo(target);
    history.pushState(null, '', link.hash);
  },
  true
);

// Alguien puede llegar con el ancla ya en la URL.
window.addEventListener('load', () => {
  const target = targetOf(window.location.hash);
  if (target) goTo(target);
});
